import Swal from 'sweetalert2'
import i18n from '@/i18n'
import { proceedWithConfirmation } from '@/lib/sweet-alert'
import { createEnpsResearch, updateEnpsResearch, applyResearch } from '@/views/enps/api'
import { notificationError, notificationSuccessfully } from '../functions'

export default {
    methods: {
        onSubmit(id, data, operation, event, send) {
            proceedWithConfirmation({
                onConfirm: async () => {
                    if (operation == 'create' || operation == 'duplicate') {
                        return createEnpsResearch(data)
                    } else if (operation == 'create-apply') {
                        const research = await createEnpsResearch(data)
                        await this.onApplyResearch(research.id)
                        this.$emit('update-expired-date', research.expired_date)
                        this.$bvModal.show('notificationSuccessfully')
                    } else if (operation === 'update') {
                        return updateEnpsResearch(id, data)
                    }
                },
                callback: () => {
                    notificationSuccessfully(operation)
                    this.goBack(send)
                    this.$emit(event)
                },
                onError: () => {
                    notificationError()
                },
            })
        },
        onCancel(send) {
            this.goBack(send)
        },
        goBack(send) {
            this.$bvModal.hide(send)
            setTimeout(() => this.$router.go(-1), 150)
        },
        onApplyResearch(id) {
            Swal.getActions().style.display = 'none'
            Swal.getTitle().innerHTML = `<span style="color:#022b4f">${i18n.t('enps.modal.applyingTitle')}</span>`
            Swal.getContent().innerHTML = `
                <div class="d-flex justify-content-center">
                    <p style="mb-2">${i18n.t('enps.modal.applyingMessage')}</p>
                </div>
                <div class="d-flex justify-content-center" style="font-size:44px;">
                    <i class="fa fa-spinner fa-spin fa-10x"></i>
                </div>`
            return applyResearch(id)
        },
    },
}
